import { RouteObject } from 'react-router';

import { ROUTES } from '~shared/routes';

export const patientRoutes: RouteObject = {
  children: [
    {
      path: ROUTES.patient.add,
      lazy: async () => {
        const { PatientFormPage } =
          await import('../../../pages/patient/PatientForm.page');

        return { Component: PatientFormPage };
      },
    },
    {
      path: ROUTES.patient.search,
      lazy: async () => {
        const { PatientPage } =
          await import('../../../pages/patient/Patient.page');

        return { Component: PatientPage };
      },
    },
  ],
};
